/**
 * 動畫效果等級（spec 23.3）。
 *
 * 預設是 `full`——所有動畫都顯示，**不看作業系統的 `prefers-reduced-motion`**。
 * 這是刻意的產品決定：這個工具的動態本來就克制，而樹懶待機那種
 * 一分鐘換兩三次的淡入淡出，被系統設定整個關掉之後看起來像畫面壞了。
 *
 * 需要的人仍然關得掉：選 `system` 就交還給作業系統，選 `reduced` 就一律關閉。
 */
export const MOTION_LEVELS = ['full', 'system', 'reduced'] as const;

export type MotionLevel = (typeof MOTION_LEVELS)[number];

export const DEFAULT_MOTION_LEVEL: MotionLevel = 'full';

export function isMotionLevel(value: unknown): value is MotionLevel {
  return typeof value === 'string' && (MOTION_LEVELS as readonly string[]).includes(value);
}

/** 這個等級加上目前的系統設定，實際上要不要減少動態。 */
export function resolveReducedMotion(level: MotionLevel, systemPrefersReduce: boolean): boolean {
  if (level === 'reduced') return true;
  if (level === 'system') return systemPrefersReduce;
  return false;
}

export const MOTION_LEVEL_LABELS: Record<MotionLevel, string> = {
  full: '完整動畫',
  system: '跟隨系統設定',
  reduced: '減少動態',
};
